import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import sortBy from 'lodash/sortBy';
import { withBrand } from '../../../../providers/BrandProvider';
import getHash from '../../../../utils/getHash';

import ModalSessionInfo from '../../../shared/ModalSessionInfo/ModalSessionInfo';
import AgendaTimeStatus from '../../../shared/AgendaTimeStatus/AgendaTimeStatus';

import './PersonContentList.scss';

export class PersonContentList extends Component {
  static propTypes = {
    list: PropTypes.array,
    brand: PropTypes.object,
    locale: PropTypes.string,
    history: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      sessionModalOpened: false,
      currentSessionIndex: 0,
    };
    this.closeSessionModal = this.closeSessionModal.bind(this);

    props.list.forEach((item, i) => {
      item.itemHash = this.getSessionHash(item);
      item.index = i;
    });
  }

  componentDidMount() {
    this.checkActiveSessionFromURL(true);
  }

  componentDidUpdate() {
    if (!this.state.sessionModalOpened) {
      this.checkActiveSessionFromURL();
    }
  }

  checkActiveSessionFromURL(fromHistory) {
    const sessionHash = this.props.history.location.hash.slice(1);
    if (sessionHash.length) {
      this.showSessionPopupHandler(sessionHash, fromHistory);
    } else if (fromHistory) {
      this.setState({
        sessionModalOpened: false,
      });
    }
  }

  showSessionPopupHandler(itemHash) {
    const currentSession = this.props.list.find(
      (item) => item.itemHash === itemHash,
    );

    if (currentSession) {
      this.setState((state) => {
        return {
          sessionModalOpened: !state.sessionModalOpened,
          currentSessionIndex: currentSession.index,
        };
      });
    } else {
      this.props.history.push(this.props.history.location.search + '#');
    }
  }

  closeSessionModal() {
    this.setState({
      sessionModalOpened: false,
    });

    // this.currentSessionIndex = null;
    this.props.history.push(this.props.history.location.search + '#');
  }

  updateLocationHistory(session) {
    this.props.history.push(
      `${this.props.history.location.search}#${this.getSessionHash(session)}`,
    );
  }

  getSessionHash(session) {
    return (
      (session.streamName ? getHash(session.streamName) + '_' : '') +
      getHash(session.title)
    );
  }

  render() {
    const { list = [], brand, locale, t } = this.props;
    const { sessionModalOpened, currentSessionIndex } = this.state;
    const sortList = sortBy(list, [
      (d) => (d.date ? d.date : `0${d.title}`),
      (d) => (d.date ? new Date(`${d.date}T${d.startTime}`).getTime() : d.date),
    ]);

    return (
      <ul className="person-content-list">
        {sortList.map((item, i) => {
          item.locale = locale;

          return (
            <li
              key={i}
              className="person-content-list__item"
              style={{ borderColor: brand.primaryColor }}
            >
              <p className="person-content-list__item-title">{item.title}</p>
              <div className="row">
                <div className="col-xs-6">
                  <AgendaTimeStatus
                    session={item}
                    isProfileLocation
                    isBoldStatus
                  />
                </div>
                <div className="col-xs-6 person-content-list__item-link">
                  <span onClick={() => this.updateLocationHistory(item)}>
                    {t('event.organisations.view-sessions')}
                    <i
                      className="fa fa-chevron-right person-content-list__item-icon"
                      style={{ color: brand.accentColor }}
                    />
                  </span>
                </div>
              </div>
            </li>
          );
        })}
        {sessionModalOpened && (
          <ModalSessionInfo
            sessionIndex={currentSessionIndex}
            sessions={list}
            brand={brand}
            closeModal={this.closeSessionModal}
          />
        )}
      </ul>
    );
  }
}

export default withTranslation()(withRouter(withBrand(PersonContentList)));
